import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import SliderListItem from '../../../../../../list-items/SliderListItem';
import { previewHistoryBatch } from '../../../../store/extensions';

const TextShadowAngleListItem = (props) => {
    const { shadowSettingsAngle, updateTextElement, index } = props;
    
    const onShadowAngleChange = (value) => {
        previewHistoryBatch.start();
        
        updateTextElement(index, { 
            shadowSettings: { angle: value } 
        });
    };
    
    return (
        <SliderListItem
            title='Angle'
            value={shadowSettingsAngle}
            min={0}
            max={360}
            step={1}
            onValueChange={onShadowAngleChange}
        />
    );
};

const mapStateToProps = (state, ownProps) => {
    const element = state.createPreview.present.videoSettings.text.textElements[ownProps.index];
    const shadowSettingsAngle = element && element.shadowSettings ? (element.shadowSettings.angle ?? 45) : 45;

    return { shadowSettingsAngle };
}

const mapDispatchToProps = (dispatch) => {
    const updateTextElement = (index, properties) => dispatch(createActions.updateTextElement(index, properties));
    return { updateTextElement }
}

export default connect(mapStateToProps, mapDispatchToProps)(TextShadowAngleListItem);
